/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { isMacOs } from '@jira/platform__os-detection/src/isMacOs.tsx';

export const getShortcutModifierKey = (): 'meta' | 'ctrl' => (isMacOs() ? 'meta' : 'ctrl');
